import SweetAlertVuetify from './SweetAlertVuetify'

// Default export is installable instance of component.
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),
export default /*#__PURE__*/ (() => {
	// Get component instance
	const installable = SweetAlertVuetify

	// Attach install function executed by Vue.use()
	// eslint-disable-next-line max-statements
	installable.install = (Vue, vuetify = null, optionsUse = {}) => {
		if (!vuetify) {
			console.error('Use Vue.use(SweetAlertVuetify, vuetify)')
		}
		const property = optionsUse.property || '$swal'
		const Ctor = Vue.extend(Object.assign({
			vuetify,
		}, SweetAlertVuetify))
		// eslint-disable-next-line init-declarations
		let cmp

		function createDialogCmp(options) {
			cmp?.close()
			const container = document.querySelector('[data-app=true]') || document.body
			return new Promise(resolve => {
				cmp = new Ctor(Object.assign({}, {
					propsData: Object.assign({}, options),
					destroyed: () => {
						container.removeChild(cmp.$el)
						resolve(cmp.valueReturn)
					},
				}))
				container.appendChild(cmp.$mount().$el)
			})
		}

		function open(alertDefault, config = {}) {
			return createDialogCmp({
				alertDefault,
				config,
				closeDestroy: true,
				modelSweet: true,
			})
		}

		function close() {
			cmp?.close()
		}

		Vue.prototype[property] = open
		Vue.prototype[property].close = close
		Vue.component('SweetAlertVuetify', installable)
	}
	return installable
})()
